import React from "react";

const Spinner = () => {
  return (
    <div
      className=" spinner-border spinner-border-custom-4 text-primary loader-img"
      role="status"
    ></div>
  );
};

export default Spinner;
